import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import Measure from 'react-measure';

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import { formatTimespent } from "../../../../services/report.service";
import { Col, Row } from 'react-bootstrap';
import { localizedStrings } from "../../../../../localization/index"
import Truncate from 'src/components/truncate';

class UserGroupListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const name = _.get(this.props.item, 'userGroup.name') || ' ';
    return (
      <a href={`/settings/user-management/group/${this.props.item.userGroup.id}`} target='_blank' className={cx(styles.item, entityStyles.userGroup, this.props.className)}>
        <div className={cx(styles.icon, entityStyles.icon)}>{name[0]}</div>
        <div>
          <h5 className={styles.title}>
            <Truncate width={300}>{name}</Truncate>
          </h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.views', '')} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
            <li>{_.get(this.props.item, 'analytics.shares', 0)} {this.localizedTabsCommons.shares}</li>
          </ul>
        </div>
      </a>
    );
  }
}

class UserGroupGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const name = _.get(this.props.item, 'userGroup.name') || ' ';
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <a href={`/settings/user-management/group/${this.props.item.userGroup.id}`} target='_blank' className={cx(styles.item, entityStyles.userGroup, this.props.className)}>
            <div className={cx(styles.icon, entityStyles.icon)}>{name[0]}</div>
            <div>
              <h5 className={styles.title}>{name}</h5>
              <ul className={styles.metrics}>
                <li>{this.localizedTabsCommons.users}: {_.get(this.props.item, 'userGroup.usersCount', 0)}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views', 0)}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.shares', 0)}</Col>
      </Row>
    );
  }
}

const UserGroup = {};
UserGroup.List = UserGroupListItem;
UserGroup.Grid = UserGroupGridItem;

export default UserGroup;